import { z } from 'zod';

import { ValueTypeFilterSchema } from '@/features/stacktrace/product-central/values/-constants';
import {
  ValueLayer,
  ValueType,
} from '@/features/stacktrace/product-central/values/-query/type';

import { ValueTableColumns } from './-table/type';

const valueLayerValues = Object.values(ValueLayer) as [string, ...string[]];

export const ValueListPageFilterSchema = z.object({
  // デフォルトは「価値約束」(PROMISE)
  valueType: ValueTypeFilterSchema.default(ValueType.PROMISE),
  layer: z.enum(valueLayerValues).optional(),
  freeText: z.string().optional(),
  pageIndex: z.coerce.number().min(0).default(0),
  pageSize: z.coerce.number().min(1).max(1000).default(100),
  sortColumn: z.nativeEnum(ValueTableColumns).optional(),
  orderDirection: z.enum(['asc', 'desc']).default('desc'),
});
